import { Injectable } from '@angular/core';

@Injectable()
export class TranslateService {

    private translations: any = { };

    constructor(
    ) {
        this.translations = window['translations'];
    }

    public translate(key: string): string {
        return this.translations[key] || key;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/translate.service.ts